import { useEffect, useState } from "react";
import axios from '../helpers/axios';

export const createNewPromotion = async (values, callback) => {
    const res = await axios.post(`/promotion/createpromotion`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const updatePromotion = async (id, values, callback) => {
    const res = await axios.put(`/promotion/updatepromotion/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const deletePromotion = async (id, values, callback) => {
    const res = await axios.put(`/promotion/deletepromotion/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const getAllPromotions = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/promotion/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const getPromotionById = async (id, callback) => {
    await axios.get(`/promotion/${id}`).then(res => {
        if (res.status === 200) {
            callback(res.data.response.data);
        } else {
            callback(res.data.response.data);
        }
    })
}

export const getPromotionByExpired = async (callback) => {
    await axios.get(`/promotion/expire-promotion`).then(res => {
        if (res.status === 200) {
            callback(res.data.response.data);
        } else {
            callback(res.data.response.data);
        }
    })
}

export const getPromotionsByDateRange = async (rowPerPage, pageNumber, startDate, endDate, callback) => {
    const res = await axios.get(`/promotion/betweendaterange/${startDate}&${endDate}?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const PromotionAPI = () => {
    const [promotions, setPromotions] = useState([]);
    const [expiredPromotion, setExpiredPromotion] = useState([]);
    const [promotionDetail, setPromotionDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [promoId, setPromoId] = useState(0);

    useEffect(() => {
        getAllPromotions(rowPerPage, pageNumber, search, res => {
            setPromotions(res);
            setTotalPages(res.totalPages || 1);
        })

        getPromotionById(promoId, res => {
            setPromotionDetail(res);
        })

        getPromotionByExpired(res => {
            setExpiredPromotion(res)
        })

    }, [promoId, callback, rowPerPage, search, pageNumber])

    return {
        promotions: [promotions, setPromotions],
        expiredPromotion: [expiredPromotion, setExpiredPromotion],
        promotionDetail: [promotionDetail, setPromotionDetail],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback],
        promoId: [promoId, setPromoId]
    }
}